import React from 'react'
import './style.css'

export default ({loading}) =>(
    <div id='loadingbar' className={loading}/>
)


// WEBPACK FOOTER //
// ./src/views/loadingbar/component.js